export default __webpack_public_path__ + "static/media/inspection_medium.61f49d71.png";